import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { TimerOutlined } from '@mui/icons-material';
import { useFacilityMaintenanceEditor } from '../../../../../hooks/useFacilityMaintenanceEditor';
import { EditorMode } from '../../../../../types/editorTypes';

interface Props {
  mode: EditorMode;
}

export const FacilityMaintenanceActualDurationEditor: React.FC<Props> = ({ mode }) => {
  const { request, updateRequest } = useFacilityMaintenanceEditor(mode);

  const handleChange = (value: string) => {
    updateRequest({ actualDuration: value });
  };

  return (
    <TextField
      label="Actual Duration"
      value={request?.actualDuration || ''}
      onChange={(e) => handleChange(e.target.value)}
      size="small"
      fullWidth
      placeholder="e.g., 2 hours, 3 days"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <TimerOutlined sx={{ color: '#64748b', fontSize: 18 }} />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default FacilityMaintenanceActualDurationEditor;
